import React from "react";

const MainLayout = props => {
  return (
    <se-container se-theme="light" position="absolute" direction="column">
      <se-header app-title="Microgrid Assessment">
        <div slot="end"></div>
      </se-header>

      <se-tabbar color="primary" aria-label="terms-layout-tabbar"></se-tabbar>
      {props.children}
    </se-container>
  );
};

export default MainLayout;
